import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { ButtonGroup, Button, Row, Col, Form } from 'react-bootstrap';
import { find, isEmpty, isNil } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import Layers from '../../../api/Layers/Layers';
import MapServerElements, {
  MAPSERVERELEMENTS_TYPES
} from '../../../api/MapServerElements/MapServerElements';
import * as mseOps from '../../../api/MapServerElements/map-server-element-operations';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import PageHeader from '../../atoms/PageHeader';
import Loading from '../../components/Loading';
import TableList from '../../components/TableList';
import NotFound from '../NotFound';

const handleRemove = async (mapServerElementId, history) => {
  try {
    await methodPromise('mapServerElements.softDelete', mapServerElementId);
    Bert.alert('Layer Server deleted!', 'warning');
    history.push(`/layerServers`);
  } catch (error) {
    handleErrorInClient(error);
  }
};

const ViewMapServerElement = ({ history, layerList, loading, mapServerElement, match }) => {
  if (loading) return <Loading />;
  if (mseOps.isDeleted(mapServerElement)) return <NotFound />;

  const tableHeaders = [
    {
      count: layerList.length,
      name: 'Layers'
    },
    {
      isHiddenOnXS: true,
      name: 'Last Updated'
    },
    {
      isHiddenOnXS: true,
      name: 'Created'
    },
    {
      isButtonColumn: true
    }
  ];
  const tablePageHeaderProps = {
    newItems: [],
    isPremium: true,
    hasSearchInput: false
  };
  const tableHeaderRowProps = { tableHeaders };
  const tableContentProps = {
    customURL: '/layers',
    deleteButton: false,
    history,
    isPremium: true,
    isTableEmpty: isEmpty(layerList),
    items: layerList,
    itemIdentifier: 'id',
    itemName: 'Layers',
    loading,
    match,
    numberOfColumns: 4,
    openNewTabButton: true
  };

  const { humanValue } = find(
    MAPSERVERELEMENTS_TYPES.properties,
    ['value', mseOps.getType(mapServerElement)],
    {}
  );

  return (
    <>
      <PageHeader>
        <h4 className="mr-auto">{mseOps.getName(mapServerElement)}</h4>
        <ButtonGroup size="sm">
          <Button onClick={() => history.push(`${match.url}/edit`)} variant="outline-info">
            Edit
          </Button>
          <Button
            onClick={() => handleRemove(mapServerElement._id, history)}
            variant="outline-danger"
          >
            Delete
          </Button>
        </ButtonGroup>
      </PageHeader>
      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <Form.Group as={Row}>
            <Form.Label column xs={12} sm={6}>
              Type
            </Form.Label>
            <Col xs={12} sm={6}>
              <Form.Control value={humanValue} readOnly className="text-truncate" plaintext />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column xs={12} sm={6}>
              Layer Server Url
            </Form.Label>
            <Col xs={12} sm={6}>
              <Form.Control
                value={mseOps.getMapServerUrl(mapServerElement)}
                readOnly
                className="text-truncate"
                plaintext
              />
            </Col>
          </Form.Group>
          <Button onClick={() => history.push(`${match.url}/newLayer`)} variant="success">
            Save as Layer
          </Button>
        </Col>
        <Col xs={12} md={6}>
          <TableList
            childProps={{
              tablePageHeaderProps,
              tableHeaderRowProps,
              tableContentProps
            }}
            isFreeUserAtLimit={false}
          />
        </Col>
      </Row>
    </>
  );
};

ViewMapServerElement.defaultProps = {
  layerList: [],
  mapServerElement: {}
};

ViewMapServerElement.propTypes = {
  history: PropTypes.object.isRequired,
  layerList: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  mapServerElement: PropTypes.object,
  match: PropTypes.object.isRequired
};

export default withTracker(({ match }) => {
  const mapServerElementId = match.params.mapServerElement_id;
  const mapServerElementsSub = Meteor.subscribe('mapServerElements.view', mapServerElementId);
  const layersSub = Meteor.subscribe('layers');

  const mapServerElement = MapServerElements.findOne(mapServerElementId);
  let mapServerElementUrl = '';
  if (!isNil(mapServerElement)) mapServerElementUrl = mseOps.getMapServerUrl(mapServerElement);

  return {
    layerList: Layers.find({ url: mapServerElementUrl, deleted: { $eq: 'no' } }).fetch(),
    loading: !mapServerElementsSub.ready() || !layersSub.ready(),
    mapServerElement
  };
})(ViewMapServerElement);
